import { render, staticRenderFns } from "./chartRender.vue?vue&type=template&id=54812d2c&scoped=true&"
import script from "./chartRender.vue?vue&type=script&lang=js&"
export * from "./chartRender.vue?vue&type=script&lang=js&"
import style0 from "./chartRender.vue?vue&type=style&index=0&id=54812d2c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54812d2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54812d2c')) {
      api.createRecord('54812d2c', component.options)
    } else {
      api.reload('54812d2c', component.options)
    }
    module.hot.accept("./chartRender.vue?vue&type=template&id=54812d2c&scoped=true&", function () {
      api.rerender('54812d2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/charts/chartRender.vue"
export default component.exports